import qs from '@scoir/query-string'

import window from 'common/window'

const scidRegex = /colleges\/([\d]+)/i

const getScidFromUrl = () => {
  const url = window.location.pathname
  const scid = url.match(scidRegex)
  if (scid && scid.length > 1) {
    return scid[1]
  }
}

export const getParams = (ClickLabel: string, ClickLocation: string, scid?: number) => {
  const usableScid = scid || getScidFromUrl()
  const params = {
    ClickLabel,
    ClickLocation,
    scid: usableScid,
    PreviousPageUrl: window.location.href,
  }
  return qs.stringify(params)
}

export const getMetaDataParams = (RedirectClickLabel: string, RedirectClickLocation: string, scid: number) => {
  return {
    RedirectClickLabel,
    RedirectClickLocation,
    scid,
  }
}
